// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import Memo from './Memo'

function MemoList(props) {
  const expandedMemoList = props.expandedMemoList || [];
  
  const memos = (props.memos || [])
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    .map((memo) => {
      return {
        ...memo,
        expanded: expandedMemoList.includes(memo.id),
        // Use memo's own excerpt_id if available, otherwise use the one passed from props
        excerpt_id: memo.excerpt_id || props.excerpt_id
      } 
    });

  return (
    <div>
      {memos.map((memo) => {
        return (
          <Memo
            key={memo.id}
            text={memo.text}
            user_id={memo.user_id}
            time={memo.created_at}
            id={memo.id}
            excerptId={memo.excerpt_id}
            memoExpanded={props.memoExpanded}
            isExpanded={memo.expanded}
            hasEditPermission={props.hasEditPermission}
            isPending={memo.isPending}
          />
        );
      })}
    </div>
  )
}

export default MemoList;